import { ETaskStatus } from '@constants';
import { Button, Popconfirm, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { ButtonsWrapper, StyledButton, Wrapper } from './DrawerHeader.styles';

import { Icon } from '@/components/Icon';

type Props = {
  onFinish: (status: ETaskStatus) => () => void;
  isAllChecked: boolean;
};

export const DrawerHeader: React.FC<Props> = ({ onFinish, isAllChecked }) => {
  const { t } = useTranslation('CourseTranslations');

  return (
    <Wrapper>
      <div>{t('CHANGE_STATUS')}</div>
      <ButtonsWrapper>
        <Popconfirm
          placement="left"
          onConfirm={onFinish(ETaskStatus.REJECTED)}
          title={t('ARE_YOU_SURE_TO_REJECT_TASK')}>
          <Button
            icon={
              <Tooltip title={t('REJECT_TOOLTIP')}>
                <div>
                  <Icon i="Information" />
                </div>
              </Tooltip>
            }
            danger>
            {t('REJECT')}
          </Button>
        </Popconfirm>
        <Popconfirm
          placement="right"
          disabled={!isAllChecked}
          onConfirm={onFinish(ETaskStatus.APPROVED)}
          title={t('ARE_YOU_SURE_TO_APPROVE_TASK')}>
          <StyledButton disabled={!isAllChecked} type="primary">
            {t('APPROVE')}
          </StyledButton>
        </Popconfirm>
      </ButtonsWrapper>
    </Wrapper>
  );
};
